"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LENGTH = void 0;
exports.DEFAULT_LENGTH = 10;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb25zdGFudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGNBQWMsR0FBRyxFQUFFLENBQUMifQ==